var _defs, _g, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 429.27 424.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5{fill:#ba8673;}.cls-2{fill:#fdc529;}.cls-3{fill:#fff;opacity:0.4;}.cls-3,.cls-5{isolation:isolate;}.cls-4{fill:url(#Gold);}.cls-5{opacity:0.22;}.cls-6{font-size:19px;}.cls-6,.cls-7,.cls-8{fill:#a14026;}.cls-6,.cls-7{font-family:PlusJakartaSans-Bold, Plus Jakarta Sans;font-weight:700;}.cls-7{font-size:120px;letter-spacing:-0.08em;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gold",
    x1: -537.93,
    y1: 791.66,
    x2: -537.93,
    y2: 790.66,
    gradientTransform: "matrix(173.75, -173.75, -173.75, -173.75, 231153.9, 44195.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fccb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fffad2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#faf1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#edd894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d8b14c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c9961a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#e9cd76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f2dc8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffad2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11747",
    "data-name": "Group 11747"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35901",
    "data-name": "Path 35901",
    className: "cls-1",
    d: "M99.17,74.88a174,174,0,1,1,0,246.08h0A174,174,0,0,1,99.17,74.88Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1155",
    "data-name": "Ellipse 1155",
    className: "cls-2",
    cx: 222.21,
    cy: 197.92,
    r: 169.56
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35896",
    "data-name": "Path 35896",
    className: "cls-3",
    d: "M342.44,78.37,102.66,318.15a169.73,169.73,0,0,0,56.74,37.26L379.7,135.1A169.63,169.63,0,0,0,342.44,78.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35897",
    "data-name": "Path 35897",
    className: "cls-3",
    d: "M387.5,235.67,260,363.21A169.72,169.72,0,0,0,387.5,235.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35898",
    "data-name": "Path 35898",
    className: "cls-3",
    d: "M139,50.23,74.53,114.65A168.55,168.55,0,0,0,58.14,155l121.2-121.2A168.22,168.22,0,0,0,139,50.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35899",
    "data-name": "Path 35899",
    className: "cls-3",
    d: "M320.1,59.51,83.8,295.81q4.14,5.83,8.72,11.3L331.39,68.24Q325.95,63.64,320.1,59.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35902",
    "data-name": "Path 35902",
    className: "cls-1",
    d: "M138.67,114.19a122.86,122.86,0,1,1,0,173.75,122.87,122.87,0,0,1,0-173.75Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1157",
    "data-name": "Ellipse 1157",
    className: "cls-4",
    cx: 222.21,
    cy: 197.92,
    r: 122.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35900",
    "data-name": "Path 35900",
    className: "cls-5",
    d: "M106,204.59a122.84,122.84,0,0,1,206.33-90.13,122.84,122.84,0,0,0-180.3,166.89q3.22,3.48,6.7,6.7A122.44,122.44,0,0,1,106,204.59Z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(103.45 123.19) rotate(-54.68)"
  }, "C")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(111.76 111.47) rotate(-48.84)"
  }, "H")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(120.88 101.25) rotate(-44.93)"
  }, "I")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "matrix(0.75, -0.67, 0.67, 0.75, 124.46, 97.57)"
  }, "L")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(131.96 90.86) rotate(-37.54)"
  }, "L")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "matrix(0.84, -0.54, 0.54, 0.84, 139.87, 84.69)"
  }, "A")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(151 77.56) rotate(-27.33)"
  }, "R")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(355.33 153) rotate(74.79)"
  }, "C")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(359.1 166.86) rotate(80.63)"
  }, "H")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(361.19 180.41) rotate(84.54)"
  }, "I")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "matrix(0.04, 1, -1, 0.04, 361.75, 185.5)"
  }, "L")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(362.16 195.56) rotate(91.93)"
  }, "L")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(361.9 205.59) rotate(96.79)"
  }, "A")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(360.33 218.71) rotate(102.14)"
  }, "R")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(181.94 333.38) rotate(-158.28)"
  }, "C")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(168.6 328.06) rotate(-152.44)"
  }, "H")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "matrix(-0.85, -0.52, 0.52, -0.85, 156.51, 321.59)"
  }, "I")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(152.11 318.98) rotate(-145.34)"
  }, "L")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(143.82 313.26) rotate(-141.14)"
  }, "L")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "matrix(-0.72, -0.69, 0.69, -0.72, 135.96, 307.03)"
  }, "A")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(126.41 297.89) rotate(-130.92)"
  }, "R")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(176.34 244.33)"
  }, "C")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 219.17,
    y: 139.39,
    width: 17.38,
    height: 17.38
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 209.85,
    y: 133.15,
    width: 36.01,
    height: 7.44
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 208.9,
    y: 257.77,
    width: 36.01,
    height: 7.44
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 218.21,
    y: 242.08,
    width: 17.38,
    height: 17.38
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ba0035ff.svg";
export { ForwardRef as ReactComponent };